export default __webpack_public_path__ + "static/media/target.5c1b0f7c.svg";